// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/fish/pufferfish-2.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "pufferfish-2 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "pufferfish-2 1.aseprite": {
      frame: {
        x: 32,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "pufferfish-2 2.aseprite": {
      frame: {
        x: 64,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
    "pufferfish-2 3.aseprite": {
      frame: {
        x: 96,
        y: 0,
        w: 32,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 32,
        h: 32,
      },
      sourceSize: {
        w: 32,
        h: 32,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "pufferfish-2.png",
    format: "RGBA8888",
    size: {
      w: 128,
      h: 32,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 2",
        opacity: 255,
        blendMode: "normal",
      },
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    swim: [
      "pufferfish-2 0.aseprite",
      "pufferfish-2 1.aseprite",
      "pufferfish-2 2.aseprite",
      "pufferfish-2 3.aseprite",
    ],
  },
};
export const pufferfish2 = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const swim = new AnimatedSprite(spritesheet.animations.swim);

  swim.width = 64;
  swim.height = 64;
  swim.anchor.set(0.5, 0.5);

  return swim;
};
